import type { CostpointType } from '@finapp/types';

/**
 * Human-readable display labels for the real (non-UNASSIGNED) costpoints.
 * Extracted from the previously copy-pasted `getCostpointName` helpers in
 * CostpointBudgetPage.tsx and CostpointBudgetEditPage.tsx.
 */
const COSTPOINT_LABELS: Partial<Record<CostpointType, string>> = {
  cs: 'Counter-Strike',
  pubg: 'PUBG',
  admin: 'Administration',
  other: 'Other',
};

/**
 * Returns the human-readable label for a costpoint (e.g. 'cs' -> 'Counter-Strike').
 * Falls back to an upper-cased version of the raw value for anything not in the
 * lookup (e.g. 'UNASSIGNED', or an unexpected/empty value), matching the previous
 * inline implementations' fallback behavior.
 */
export function getCostpointLabel(costpoint: CostpointType | string): string {
  return COSTPOINT_LABELS[costpoint as CostpointType] ?? costpoint.toUpperCase();
}
